// src/components/info/Team.jsx
import React from 'react';
import ShortTests from '../shorts/Tests';
import ShortNews from '../shorts/News';
import { Helmet } from 'react-helmet-async';
import AdSlot from '../ads/AdSlot';

import '../../assets/css/team.css'

import ralfGlende from '../../assets/img/team/ralf-glende.jpg';
import svenKunter from '../../assets/img/team/sven-kunter.png';

// Beispiel-Teamdaten (kannst du beliebig erweitern/ändern)
const teamMembers = [
  {
    name: 'Ralf Glende',
    role: 'Gründer & Chefredakteur',
    bio: 'Gründete NGCTV 2012 und sorgt seitdem für die strategische Ausrichtung und unabhängige Berichterstattung.',
    image: ralfGlende,
  },
  {
    name: 'Sven Kunter',
    role: 'Redakteur',
    bio: 'Seit 2025 Teil des NGCTV-Teams. Schwerpunkt auf aktuelle Gaming-News und tiefgehende Artikel rund um Technik-Trends. Bringt frische Impulse und eine klare Perspektive in die Redaktion.',
    image: svenKunter,
  },
];

const Team = () => {
  const pageTitle = 'Unser Team | NGCTV';
  const pageDescription =
    'Lerne das Team von NGCTV kennen: Leidenschaftliche Köpfe hinter Gaming- und Technik-News, Tests und Community-Inhalten seit 2012.';

  return (
    <>
      {/* SEO / Head */}
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://ngctv.de/team" />
      </Helmet>

      <main>
        <div className="wrapper">
          <div className="rows">
            <div className="row">
              <div className="category">Unser Team</div>

              <div className="team">
                <p>
                  Hinter NGCTV stehen Menschen, die Gaming und Technik nicht nur berichten,
                  sondern selbst leben. Unser Team arbeitet seit 2012 daran, euch die
                  spannendsten News, Tests und Hintergründe näherzubringen – mit echter
                  Leidenschaft und engem Draht zur Community.
                </p>

                <div className="team-grid">
                  {teamMembers.map((member, idx) => (
                    <div key={idx} className="team-card">
                      {member.image && (
                        <img
                          src={member.image}
                          alt={member.name}
                          className="team-image"
                        />
                      )}
                      <h3>{member.name}</h3>
                      <p className="role">{member.role}</p>
                      <p className="bio">{member.bio}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="row">
              <ShortTests />
              <ShortNews />
              <AdSlot slot="2119524913" />
            </div>
          </div>
        </div>
      </main>

      {/* Inline-CSS für ein einfaches Grid – später in CSS-Datei auslagern */}
      <style>{`
        .team-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 20px;
          margin-top: 2rem;
        }
        .team-card {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 16px;
          text-align: center;
        }
        .team-image {
          width: 120px;
          height: 120px;
          object-fit: cover;
          border-radius: 50%;
          margin-bottom: 12px;
        }
        .role {
          font-weight: 600;
          color: #374151;
        }
        .bio {
          font-size: 0.9rem;
          color: #6b7280;
        }
      `}</style>
    </>
  );
};

export default Team;
